import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeDecision extends Shape {
    width = 200;
    height = 145;

    fitText(textPart: ShapeTextPart, x: number, y: number, width: number, height: number) {
        const k = (height * width) / (height + width);
        const allowedWidth = k;
        const allowedHeight = k;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 5, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        const rh = h / 50;
        const rw = w / 50;

        canv.ctx.beginPath();

        canv.ctx.ellipse(x + w / 2, y + rh, rw, rh, 0, Math.PI * 1.25, Math.PI * 1.75);
        canv.ctx.ellipse(x + w - rw, y + h / 2, rw, rh, 0, Math.PI * 1.75, Math.PI * 2.25);
        canv.ctx.ellipse(x + w / 2, y + h - rh, rw, rh, 0, Math.PI * 2.25, Math.PI * 0.75);
        canv.ctx.ellipse(x + rw, y + h / 2, rw, rh, 0, Math.PI * 0.75, Math.PI * 1.25);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" stroke-linejoin="round" d="m12 4 11 8-11 8-11-8 11-8Z"/>
            </svg>
        `;
    }
}
